export default "__VITE_ASSET__BiwTfrU7__"